import {
    Badge, Button, CircularProgress, Grid, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme
} from "@mui/material";
import {
    IconEdit,
    IconSortAscending2,
    IconSortDescending2,
    IconPlaylistAdd,
    IconFilter,
    IconTrash,
    IconDownload,
} from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    clearFormulaList,
    closeFormulaFilterDialog,
    closeFormulaDeleteConfrimationDialog,
    closeFormulaCreateDialog,
    getFormulaDetails,
    getformulaExport,
    getFormulaList,
    openFormulaFilterDialog,
    openFormulaDeleteConfrimationDialog,
    openFormulaCreateDialog,
    formulaListErrorClear,
    setFormulaFilteredData,
    setFormulaDeleteData,
    openFormulaeEditDialog,
    closeFormulaeEditDialog
} from "store/app/report-management/reports/actions";
import SubCard from "ui-component/cards/SubCard";
import ReportCreate from "./create";
import ReportEdit from "./edit";
import FilterReports from "./filter";
import { getPager } from "helper/common";
import MainCard from "ui-component/cards/MainCard";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { NoData } from "ui-component/custom-components/nodata";
import { VWPagination } from "ui-component/custom-components/pagination";
import moment from "moment";
import Chip from "ui-component/extended/Chip";
import FormulaDelete from "./formulaDelete";
import { excelSheetExport } from "helper/export";

const tableHeaderStyle = { paddingLeft: '0px' }

const ReportsList = (props) => {
    //--------------------List--------------------------------------
    const { formulaList, totalCounts, isPending, errorMessage } = props;

    const [pageSize, setPageSize] = useState(10);
    const [Pager, setPager] = useState({ currentPage: 1 });
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortOrder, setSortOrder] = useState(null);

    //--------------------Filter------------------------------------
    const { formulaFilterData, isFormulaFilterDialogOpen } = props;
    //--------------------Create------------------------------------
    const { isFormulaCreateDialogOpen } = props;
    //--------------------Edit--------------------------------------
    const { isFormulaDetailsPending, isFormulaEditDialogOpen } = props;
    //--------------------Delete------------------------------------
    const { formulaDeleteConfirmationDialogOpen } = props;
    //--------------------Export------------------------------------
    const { formulaExportErrorMessage, isFormulaExportPending } = props;
    //--------------------Profile-----------------------------------
    const { userProfile } = props;
    const { userRoleName } = userProfile || {};
    //--------------------UI Design---------------------------------
    const theme = useTheme();
    const colorPrimary = theme.palette.secondary.dark;
    const [tableHeight, setTableHeight] = useState(window.innerHeight);

    const dataTypeNamingConverter = (name) => {
        switch (name?.toLowerCase()) {
            case "int":
                return "Number";
            case "yes/no":
                return "Present/Absent";
            default:
                return name;
        }
    }

    useEffect(() => {
        props.formulaListErrorClear();

        const handleResize = () => {
            setTableHeight(window.innerHeight)
        };
        window.addEventListener("resize", handleResize);
        return () => {
            props.clearFormulaList();
            window.removeEventListener("resize", handleResize);
        }
    }, [])

    const handleSort = (column) => {
        if (sortOrder === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        }
        else {
            setSortOrder(column);
            setSortDirection('asc');
        }
    };

    const setPage = (page = 1) => {
        props.getFormulaList(page, pageSize, sortOrder, sortDirection, formulaFilterData);

        setPager(prevPager => {
            const totalPages = Math.ceil(totalCounts / pageSize);
            const visiblePages = 4;
            const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
            const newPages = [];
            for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
                newPages.push(i);
            }
            return {
                ...prevPager,
                currentPage: page,
                totalPages,
                pages: newPages,
            }
        })
    }

    useEffect(() => {
        const currentPager = getPager(totalCounts, 1, pageSize);
        setPager(currentPager)
    }, [totalCounts]);

    useEffect(() => {
        setPage();
    }, [formulaFilterData, sortOrder, sortDirection, pageSize])
    //--------------------------|| CREATE DIALOG ||------------------------------------------//
    const handleReportCreateOpen = () => {
        props.openFormulaCreateDialog();
    }

    const handleReportCreateClose = () => {
        props.closeFormulaCreateDialog();
    }
    //--------------------------|| EDIT DIALOG ||------------------------------------------//
    const handleReportEditOpen = (id) => {
        props.getFormulaDetails(id);
    }

    const handleReportEditClose = () => {
        props.closeFormulaEditDialog();
    }
    //--------------------------|| FILTER DIALOG ||------------------------------------------//
    const handleFilterOpen = () => {
        props.openFormulaFilterDialog();
    }
    const handleFilterClose = () => {
        props.closeFormulaFilterDialog();
    }
    //-------------------------------|| DELETE ||--------------------------------------------//
    const handleDeleteField = (e, Id, ReportName, IsFormFieldFormula) => {
        const selectFormula = {
            id: Id,
            formulaName: ReportName,
            isFormFieldFormula: IsFormFieldFormula
        }
        e.preventDefault();
        props.setFormulaDeleteData(selectFormula);
        props.openFormulaDeleteConfrimationDialog();
    }
    const handleClose = () => {
        props.closeFormulaDeleteConfrimationDialog();
    }
    //------------------------------|| EXPORT ||-------------------------------------------------//
    const handleExportFormRecords = (e) => {
        e.preventDefault();
        props.getformulaExport(sortOrder, sortDirection, formulaFilterData)
            .then((reports) => {
                if (reports) {
                    const exportReportLists = [];
                    const headerExcel = [
                        { headerName: "Formula Name", key: "reportName", headerWidhth: 20 },
                        { headerName: "Data Type", key: "dataType", headerWidhth: 20 },
                        { headerName: "Metrics", key: "metrics", headerWidhth: 30 },
                        { headerName: "Custom Formula", key: "customFormula", headerWidhth: 60 },
                        { headerName: "Created By", key: "createdBy", headerWidhth: 30 },
                        { headerName: "Created On", key: "createdTimeStamp", headerWidhth: 30 },
                    ]
                    reports && reports.forEach((element) => {
                        const formula = element.customFormula?.split(" ");
                        const formulaArray = formula?.map((ops) => {
                            const fieldArr = ops.includes("FRMFLD") ? element.fields?.filter((field) => field.fieldId === ops) : [ops];
                            const field = fieldArr[0]?.fieldName || fieldArr[0];
                            return field;
                        })
                        const formulaString = formulaArray?.join(" ");
                        exportReportLists.push({
                            reportName: element.reportName || "N/A",
                            dataType: element.dataType ? dataTypeNamingConverter(element.dataType) : "N/A",
                            metrics: element.metrics || "N/A",
                            customFormula: element.isCustomFormula ? formulaString : "N/A",
                            createdBy: element.createdBy || "N/A",
                            createdTimeStamp: element.createdTimeStamp ? moment(element.createdTimeStamp).format("DD MMM YYYY") : "N/A",
                        });
                    });
                    excelSheetExport(headerExcel, exportReportLists, "Formulae List");
                }
            })
    }

    return (
        <>
            <SubCard sx={{
                p: 1.5,
                pl: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
            >
                <Grid item sx={{ display: 'flex', gap: { lg: 2, md: 2, sm: 1, xs: 1 }, alignItems: "center", marginRight: "10px" }}>
                    <Typography variant="h4">
                        Formulae List -
                    </Typography>
                    <Tooltip title="Formulae Count" placement="top">
                        <span>
                            <Chip
                                label={totalCounts}
                                chipcolor="secondary"
                                size="small"
                                sx={{
                                    borderRadius: "20%",
                                    py: 1,
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    cursor: "pointer"
                                }}
                            />
                        </span>
                    </Tooltip>
                </Grid>
                <Grid item sx={{ display: 'flex', gap: 2, alignItems: "center" }}>
                    <Badge
                        badgeContent={formulaFilterData ? Object.keys(formulaFilterData).length : 0}
                        color="secondary"
                        invisible={formulaFilterData ? Object.keys(formulaFilterData).length === 0 : true}
                    >
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleFilterOpen}
                            startIcon={<IconFilter />}
                        >
                            Filter
                        </Button>
                    </Badge>
                    {(userRoleName === "Administrator" || userRoleName === "Master admin") &&
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleReportCreateOpen}
                            startIcon={<IconPlaylistAdd />}
                        >
                            Create Formula
                        </Button>
                    }
                    {totalCounts > 0 &&
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleExportFormRecords}
                            startIcon={!isFormulaExportPending && <IconDownload />}
                            disabled={isFormulaExportPending}
                        >
                            {isFormulaExportPending ?
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <CircularProgress size={'20px'} color='inherit' />
                                    Loading...
                                </div>
                                : <>Export</>
                            }
                        </Button>}
                </Grid>
            </SubCard>
            <MainCard sx={{ marginTop: '15px' }}>
                {errorMessage && <ErrorAlert type={'error'} content={errorMessage} />}
                {formulaExportErrorMessage && <ErrorAlert recordStatusFilter={'error'} content={formulaExportErrorMessage} />}
                <TableContainer sx={{ whiteSpace: "nowrap", maxHeight: `calc(${tableHeight}px - 380px)`, overflow: "auto" }}>
                    <Table size="small" stickyHeader aria-label="sticky table"
                        sx={{
                            '& tr > *:last-child': {
                                position: 'sticky',
                                right: 0,
                                bgcolor: 'white',
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Button sx={tableHeaderStyle}
                                        onClick={() => handleSort('ReportName')}
                                        endIcon={sortOrder === 'ReportName' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Formula Name
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('DataType')}
                                        endIcon={sortOrder === 'DataType' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Data Type
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('Metrics')}
                                        endIcon={sortOrder === 'Metrics' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Metrics
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('CustomFormula')}
                                        endIcon={sortOrder === 'CustomFormula' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Custom Formula
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('IsFormFieldFormula')}
                                        endIcon={sortOrder === 'IsFormFieldFormula' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Is Used In Form Field?
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('CreatedBy')}
                                        endIcon={sortOrder === 'CreatedBy' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Created By
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        sx={tableHeaderStyle}
                                        onClick={() => handleSort('CreatedTimeStamp')}
                                        endIcon={sortOrder === 'CreatedTimeStamp' && (
                                            sortDirection === 'asc' ?
                                                <IconSortAscending2 color={colorPrimary} />
                                                : <IconSortDescending2 color={colorPrimary} />
                                        )}
                                    >
                                        Created On
                                    </Button>
                                </TableCell>
                                {(userRoleName === "Administrator" || userRoleName === "Master admin") && <TableCell>Actions</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(formulaList?.length > 0) && !isPending ?
                                formulaList?.map((data, index) => {
                                    const formula = data.CustomFormula?.split(" ");
                                    const formulaArray = formula?.map((ops) => {
                                        const fieldArr = ops.includes("FRMFLD") ? data.Fields?.filter((field) => field.FieldId === ops) : [ops];
                                        const field = fieldArr[0]?.FieldName || fieldArr[0];
                                        return field;
                                    })
                                    const formulaString = formulaArray?.join(" ");
                                    return <TableRow key={index}>
                                        <TableCell>{data.ReportName || 'N/A'}</TableCell>
                                        <TableCell>{data.DataType ? dataTypeNamingConverter(data.DataType) : 'N/A'}</TableCell>
                                        <TableCell>{data.Metrics || 'N/A'}</TableCell>
                                        <TableCell>{data.IsCustomFormula ? formulaString : 'N/A'}</TableCell>
                                        <TableCell>{data.IsFormFieldFormula ?
                                            <Chip label={"Yes"} chipcolor="success" size="small" />
                                            : <Chip label={"No"} chipcolor="error" size="small" />
                                        }</TableCell>
                                        <TableCell>{data.CreatedBy || 'N/A'}</TableCell>
                                        <TableCell>{data.CreatedTimeStamp ? moment(data.CreatedTimeStamp).format("DD MMM YYYY") : 'N/A'}</TableCell>
                                        {(userRoleName === "Administrator" || userRoleName === "Master admin") &&
                                            <TableCell>
                                                {isFormulaDetailsPending === data.Id ?
                                                    <Grid container gap={1}>
                                                        <CircularProgress size={20} />
                                                        <Typography variant="h6" color={'primary'}> Loading...</Typography>
                                                    </Grid>
                                                    : <Tooltip title="Edit Formula" placement="top">
                                                        <IconEdit style={{ cursor: "pointer" }} onClick={() => handleReportEditOpen(data.Id)} />
                                                    </Tooltip>
                                                }
                                                <Tooltip title="Delete Formula" placement="top">
                                                    <IconTrash style={{ cursor: "pointer", color: "#C62E2E", marginLeft: "20px" }} onClick={(e) => handleDeleteField(e, data.Id, data.ReportName, data.IsFormFieldFormula)} />
                                                </Tooltip>

                                            </TableCell>
                                        }
                                    </TableRow>
                                })
                                : isPending ?
                                    <TableRow >
                                        <TableCell colSpan={9} height='300px'>
                                            <Grid container alignItems={"center"} justifyContent={"center"} gap={1}
                                                sx={{
                                                    position: "sticky",
                                                    width: "fit-content",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)"
                                                }}
                                            >
                                                <CircularProgress />
                                                <Typography variant="h5" color={'primary'}> Loading...</Typography>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                    : <TableCell colSpan={9} height='300px'>
                                        <NoData />
                                    </TableCell>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                {(totalCounts > 0) &&
                    <Grid>
                        <VWPagination
                            pageDetails={Pager}
                            pageChange={setPage}
                            totalRecords={totalCounts}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                        />
                    </Grid>
                }
            </MainCard>
            {/*--------|| CREATE DIALOG ||---------*/}
            <ReportCreate
                filters={formulaFilterData}
                paginationData={{
                    page: (Pager && Pager.currentPage) || 1,
                    pageSize: pageSize,
                    sortDirection: sortDirection,
                    sortOrder: sortOrder
                }}
                open={isFormulaCreateDialogOpen}
                onClose={handleReportCreateClose}
            />
            {/*--------|| EDIT DIALOG ||---------*/}
            <ReportEdit
                filters={formulaFilterData}
                paginationData={{
                    page: (Pager && Pager.currentPage) || 1,
                    pageSize: pageSize,
                    sortDirection: sortDirection,
                    sortOrder: sortOrder
                }}
                open={isFormulaEditDialogOpen}
                onClose={handleReportEditClose}
            />
            {/*--------|| FILTER DIALOG ||---------*/}
            <FilterReports
                open={isFormulaFilterDialogOpen}
                onClose={handleFilterClose}
                setPage={setPage}
            />
            {/*-------------------------------|| DELETE DIALOG||------------------------------------------------------*/}
            <FormulaDelete
                filter={formulaFilterData}
                paginationData={{
                    page: (Pager && Pager.currentPage) || 1,
                    pageSize: pageSize,
                    sortDirection: sortDirection,
                    sortOrder: sortOrder
                }}
                open={formulaDeleteConfirmationDialogOpen}
                handleClose={handleClose}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    //--------------------List--------------------------------------
    formulaList: state.formulae.formulaList,
    totalCounts: state.formulae.formulaListCount,
    isPending: state.formulae.isFormulaListPending,
    errorMessage: state.formulae.formulaListErrorMessage,
    //--------------------Filter------------------------------------
    isFormulaFilterDialogOpen: state.formulae.isFormulaFilterDialogOpen,
    formulaFilterData: state.formulae.formulaFilterData,
    //--------------------Create------------------------------------
    isFormulaCreateDialogOpen: state.formulae.isFormulaCreateDialogOpen,
    //--------------------Edit--------------------------------------
    isFormulaEditDialogOpen: state.formulae.isFormulaEditDialogOpen,
    isFormulaDetailsPending: state.formulae.isFormulaDetailsPending,
    //--------------------Export------------------------------------
    isFormulaExportPending: state.formulae.isFormulaExportPending,
    formulaExportErrorMessage: state.formulae.formulaExportErrorMessage,
    //--------------------Delete------------------------------------
    formulaDeleteConfirmationDialogOpen: state.formulae.formulaDeleteConfirmationDialogOpen,
    //--------------------Profile-----------------------------------
    userProfile: state.login.userProfile,

})
const mapDispatchToProps = (dispatch) => ({
    //--------------------List--------------------------------------
    getFormulaList: (page, pageSize, sortOrder, sortDirection, filter) => dispatch(getFormulaList(page, pageSize, sortOrder, sortDirection, filter)),
    clearFormulaList: () => dispatch(clearFormulaList()),
    formulaListErrorClear: () => dispatch(formulaListErrorClear()),
    //--------------------Filter------------------------------------
    openFormulaFilterDialog: () => dispatch(openFormulaFilterDialog()),
    closeFormulaFilterDialog: () => dispatch(closeFormulaFilterDialog()),
    setFormulaFilteredData: (filter) => dispatch(setFormulaFilteredData(filter)),
    //--------------------Create------------------------------------
    openFormulaCreateDialog: () => dispatch(openFormulaCreateDialog()),
    closeFormulaCreateDialog: () => dispatch(closeFormulaCreateDialog()),
    //--------------------Edit--------------------------------------
    getFormulaDetails: (id) => dispatch(getFormulaDetails(id)),
    openFormulaEditDialog: () => dispatch(openFormulaeEditDialog()),
    closeFormulaEditDialog: () => dispatch(closeFormulaeEditDialog()),
    //--------------------Export------------------------------------
    getformulaExport: (sortOrder, sortDirection, filter) => dispatch(getformulaExport(sortOrder, sortDirection, filter)),
    //--------------------Delete------------------------------------
    openFormulaDeleteConfrimationDialog: () => dispatch(openFormulaDeleteConfrimationDialog()),
    closeFormulaDeleteConfrimationDialog: () => dispatch(closeFormulaDeleteConfrimationDialog()),
    setFormulaDeleteData: (selectedFormula) => dispatch(setFormulaDeleteData(selectedFormula)),

})

export default connect(mapStateToProps, mapDispatchToProps)(ReportsList);